import { logout, userIcon } from '../../assets/images/dashboard-business';
import { TUserloggedInDetails } from '../../types';
import { Link, useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../app/hooks';
import jwtDecode from 'jwt-decode';

const LogoutCard = () => {
  const token: any = localStorage.getItem('login-token');

  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.removeItem('login-token');
    localStorage.removeItem('login-phone');
    localStorage.removeItem('login-email');
    localStorage.removeItem('sessId');
    localStorage.removeItem('paymentToken');
    localStorage.removeItem('package');
    localStorage.removeItem('package-id');
    localStorage.removeItem('package-price');
    localStorage.removeItem('businessId');

    navigate('/');
    window.location.reload();
  };

  const { profile, lastName, firstName, email }: TUserloggedInDetails = jwtDecode(token);
  return (
    <div className='py-3 px-4 rounded-sm flex flex-col gap-3 absolute top-[40px] right-[-50px] bg-[white] shadow-lg z-[1000]'>
      <Link to={'/settings/profile-information'}>
        <div className='text-center cursor-pointer'>
          <img
            src={profile?.photo ?? userIcon}
            className='pb-2 rounded-[50%] h-[120px] w-[100px]'
          />
          <div className='pb-1 font-bold'>{firstName + ` ` + lastName}</div>
          <div className='text-xs'>{email}</div>
        </div>
      </Link>
      <div
        className='flex bg-[#EAF0FA] p-2 justify-center cursor-pointer'
        onClick={() => handleLogout()}
      >
        <div className='flex gap-2'>
          <img src={logout} alt='' />
          Logout
        </div>
      </div>
    </div>
  );
};

export default LogoutCard;
